/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_Email_PlaceholderInputs */

const en_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const de_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const fr_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const es_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const it_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@universita.edu`)
};

const nl_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const pl_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const fi_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@university.edu`)
};

const da_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@universitet.dk`)
};

const sv_onboarding_verify_email_placeholder = /** @type {(inputs: Onboarding_Verify_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@universitet.se`)
};

/**
* | output |
* | --- |
* | "you@university.edu" |
*
* @param {Onboarding_Verify_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_email_placeholder = /** @type {((inputs?: Onboarding_Verify_Email_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_Email_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_email_placeholder(inputs)
	if (locale === "fr") return fr_onboarding_verify_email_placeholder(inputs)
	if (locale === "es") return es_onboarding_verify_email_placeholder(inputs)
	if (locale === "it") return it_onboarding_verify_email_placeholder(inputs)
	if (locale === "nl") return nl_onboarding_verify_email_placeholder(inputs)
	if (locale === "pl") return pl_onboarding_verify_email_placeholder(inputs)
	if (locale === "fi") return fi_onboarding_verify_email_placeholder(inputs)
	if (locale === "da") return da_onboarding_verify_email_placeholder(inputs)
	if (locale === "sv") return sv_onboarding_verify_email_placeholder(inputs)
	return en_onboarding_verify_email_placeholder(inputs)
});